/**
 * Route-level tab-close warning for background equipment creates.
 *
 * Create Equipment and the ticket form's quick-create both close on submit, and the
 * ticket form can be cancelled or its placeholder dropped with "Change" — yet the
 * create (and its contact attach) keeps running in this tab. A warning mounted in any
 * of those forms would stop as soon as the form went away, so it is mounted ONCE, in
 * ModuleLayout, and keys off the running mutation itself.
 *
 * Renders nothing. Safe without a QueryClientProvider above it (some layout tests
 * render ModuleLayout bare): there, no create can be running, so it does nothing.
 *
 * @module components/Equipment/WarnWhileCreatingEquipment
 */
import { useContext } from 'react';
import { QueryClientContext } from '@tanstack/react-query';
import { useWarnWhileCreatingEquipment } from '../../hooks/equipment/useCreateEquipment';

function ActiveWarning(): null {
  useWarnWhileCreatingEquipment();
  return null;
}

export function WarnWhileCreatingEquipment() {
  const queryClient = useContext(QueryClientContext);
  return queryClient ? <ActiveWarning /> : null;
}
